module.exports = __webpack_public_path__ + "img/barcode-scan-result 1.c2c4c1e2.png";